import { render } from "./Audiodeldia.vue?vue&type=template&id=4df6b834&scoped=true&ts=true"
import script from "./Audiodeldia.vue?vue&type=script&lang=ts"
export * from "./Audiodeldia.vue?vue&type=script&lang=ts"

import "./Audiodeldia.vue?vue&type=style&index=0&id=4df6b834&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df6b834"]])

export default __exports__